module.exports = __webpack_public_path__ + "static/media/background.b87c243e.gif";